export function makeSortableId(el) {
  return `${el.type}:${el.id}`;
}

export function parseSortableId(id) {
  const [type, rawId] = String(id).split(":");
  if (rawId === undefined) {
    return { type: "undefined", id: Number.NaN };
  }
  return { type, id: Number(rawId) };
}

export function reorderArray(list, fromIndex, toIndex) {
  const next = list.slice();
  const [moved] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, moved);
  return next.map((x, idx) => ({ ...x, order: idx }));
}

export function removeFromArray(list, predicate) {
  const idx = list.findIndex(predicate);
  if (idx === -1) return { list, removed: null, index: -1 };
  const next = list.slice();
  const [removed] = next.splice(idx, 1);
  return { list: next.map((x, i) => ({ ...x, order: i })), removed, index: idx };
}

export function insertIntoArray(list, element, index) {
  const next = list.slice();
  const clamped = Math.max(0, Math.min(index, next.length));
  next.splice(clamped, 0, element);
  return next.map((x, i) => ({ ...x, order: i }));
}


